import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'googlemap-overlay',
  templateUrl: './googlemap-overlay.component.html',
  styleUrls: ['./googlemap-overlay.component.css']
})
export class GooglemapOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
